var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tabs',{staticClass:"iv-tab",attrs:{"value":_vm.value,"size":"small"},on:{"on-click":_vm.tabClick}},[_vm._l((_vm.navList),function(item,index){return _c('TabPane',{key:index,attrs:{"icon":item.icon || '',"label":item.label,"name":item.name || `${index}`}})}),_c('template',{slot:"extra"},[_vm._t("extra")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }